class PickupAvailabilityCompact extends HTMLElement {

  constructor(){

    super();
    this.classList.add('active');
    this.retries = 5
    this.helperSectionId = 'helper-pickup-availability-compact'
    this.storeSelector = document.querySelector('store-selector[data-main-selector]');
    this.productItem = this.closest('product-item')

    if ('IntersectionObserver' in window) {
      const widgetIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.fetchAvailability(this.dataset.variantId);
      }
      new IntersectionObserver(widgetIntersection.bind(this), {rootMargin: '0px 0px 160px 0px'}).observe(this);
    } else {
      this.fetchAvailability(this.dataset.variantId);
    }

    document.addEventListener('storechanged', () => {
      this.storeSelector = document.querySelector('store-selector[data-main-selector]');
      this.fetchAvailability(this.dataset.variantId);
    });

    if (this.productItem) {
      this.productItem.addEventListener('variant-selector:changed', (event) => {
        const { id } = event.detail
        this.fetchAvailability(id);
      })
    }
  }

  fetchAvailability(variantId) {
    this.dataset.variantId = variantId;
    const requestId = this.requestId = (this.requestId || 0) + 1;

    const variantSectionUrl = `${this.dataset.baseUrl}/variants/${variantId}/?section_id=${this.helperSectionId}`;
    PickupAvailabilityCompact.fetchSection(variantSectionUrl)
      .then(response => response.text())
      .then(text => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.shopify-section');
        if (requestId === this.requestId) this.renderPreview(sectionInnerHTML);
      })
      .catch(e => {
        console.log(e);
      });

  }

  static fetchSection(url) {
    if (!this.sectionCache) this.sectionCache = new Map();
    if (!this.sectionCacheTimes) this.sectionCacheTimes = new Map();
    if (!this.sectionCache.has(url) || Date.now() - (this.sectionCacheTimes.get(url) || 0) > 15000) {
      this.sectionCacheTimes.set(url, Date.now());
      const request = fetch(url).catch(error => {
        this.sectionCache.delete(url);
        throw error;
      });
      this.sectionCache.set(url, request);
    }
    return this.sectionCache.get(url).then(response => response.clone());
  }

  renderPreview(sectionInnerHTML) {

    const selectedStore = localStorage.getItem('selected-store');

    if (!sectionInnerHTML) {
      this.innerHTML = '';
      return
    }

    if (this.storeSelector && !this.storeSelector.storesList && this.retries > 0) {
      this.retries -= 1
      setTimeout(() => this.renderPreview(sectionInnerHTML), 1000)
      return
    }

    if ( this.storeSelector && selectedStore && this.storeSelector.storesList[selectedStore] ) {
      // search based on selected store
      let storeFound = false;
      if ( selectedStore ) {
        sectionInnerHTML.querySelectorAll('.pickup-availability-alert').forEach(elm=>{
          if ( selectedStore == elm.dataset.store ) {
            const storeName = this.storeSelector.storesList[selectedStore].replace('Shop Santé ', '')
            this.innerHTML = elm.innerHTML.replace('{{ store }}', storeName);
            storeFound = true;
          }
        })
      }
      if ( !storeFound ) {
        this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-alert[data-default-unavailable]').innerHTML.replace('{{ store }}', this.storeSelector.storesList[selectedStore]);
        storeFound = true;
      }
      if ( !selectedStore || !storeFound ) {
        this.innerHTML = '';
      }
    } else if (selectedStore) {
      this.innerHTML = '';
    } else {
      // search based on default store
      const defaultStore = sectionInnerHTML.querySelector('.pickup-availability-alert[data-default-store]')
      this.innerHTML = defaultStore ? defaultStore.innerHTML : '';
    }

  }

}

if ( typeof customElements.get('pickup-availability-compact') == 'undefined' ) {
  customElements.define('pickup-availability-compact', PickupAvailabilityCompact);
}

if ( typeof PickupAvailabilityMinimal !== 'function' ) {

  class PickupAvailabilityMinimal extends PickupAvailabilityCompact {

    constructor(){

      super();
      this.helperSectionId = 'helper-pickup-availability-minimal'

    }

  }

  if ( typeof customElements.get('pickup-availability-minimal') == 'undefined' ) {
    customElements.define('pickup-availability-minimal', PickupAvailabilityMinimal);
	}

}

if ( typeof PickupAvailabilityExtended !== 'function' ) {

  class PickupAvailabilityExtended extends HTMLElement {

    constructor() {
      super();
      this.classList.add('active');
      this.fetchAvailability(this.dataset.variantId);
    }


    fetchAvailability(variantId) {

      const variantSectionUrl = `${this.dataset.baseUrl}/variants/${variantId}/?section_id=helper-pickup-availability-extended`;

      PickupAvailabilityCompact.fetchSection(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(e => {
          console.log(e);
        });

    }

    renderPreview(sectionInnerHTML) {
      const availabilityWidget = sectionInnerHTML.querySelector('#PickupAvailabilityWidget');
      if ( availabilityWidget ) {
        this.innerHTML = availabilityWidget.innerHTML;
        this.querySelectorAll('.pickup-availability-widget__location-view').forEach(elm=>{
          elm.addEventListener('click', ()=>{
            document.getElementById(`${elm.getAttribute('aria-controls')}`).classList.toggle('opened');
            elm.setAttribute('aria-selected', elm.getAttribute('aria-selected') == "true" ? "false" : "true");
          })
        })
      } else {
        console.log('error in availablity fetch');
      }

      const availabilitySidebar = sectionInnerHTML.querySelector('#PickupAvailabilitySidebar');
      if ( availabilitySidebar ) {
        if ( document.querySelector('sidebar-drawer#site-availability-sidebar') ) {
          document.querySelector('sidebar-drawer#site-availability-sidebar').remove();
        }
        document.body.appendChild(availabilitySidebar.querySelector('#site-availability-sidebar'));
        document.querySelector('.pickup-availability-widget__more').addEventListener('click', e=>{
          e.preventDefault();
          document.getElementById('site-availability-sidebar').show();
        })
      }

    }

  }

  if ( typeof customElements.get('pickup-availability-extended') == 'undefined' ) {
    customElements.define('pickup-availability-extended', PickupAvailabilityExtended);
	}

}
